import { useQuery } from 'react-query';

import { TRIAL_SIGNUP_QUERY_KEYS } from '../constants';
import {
  verifyTrialInvite,
  type VerifyTrialInvitePayload,
  type VerifyTrialInviteResponse,
} from '../request';

type UseVerifyTrialInviteQueryParams = VerifyTrialInvitePayload & {
  enabled: boolean;
};

export const useVerifyTrialInviteQuery = ({
  id,
  verification_code,
  enabled,
}: UseVerifyTrialInviteQueryParams) =>
  useQuery<VerifyTrialInviteResponse, Error>(
    [TRIAL_SIGNUP_QUERY_KEYS.VERIFY, id, verification_code],
    ({ signal }) => verifyTrialInvite({ id, verification_code }, signal),
    {
      enabled,
      staleTime: Infinity,
      cacheTime: 0,
    }
  );
